import type { DialogStore } from "@ariakit/react";
import { useCallback } from "react";

export function useCloseOnInteract(store: DialogStore) {
  return useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (
        event.target instanceof HTMLElement &&
        event.target.closest("a, button")
      ) {
        store.hide();
      }
    },
    [store],
  );
}
